import styled from "styled-components";

export const WebViewContainer = styled.div`
  backgroundcolor: ${(props) => props.theme.color.gray100};
  overflow: "scroll";
`;

export const NoLoyaltyText = styled.p`
  color: ${(props) => props.theme.color.gray400};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-size: ${(props) => props.theme.fontSize.headline};
  text-align: center;
  margin-top: 45vh;
`;

export const HeaderContainer = styled.div`
  background-color: ${(props) => props.theme.color.white};
  position: fixed;
  width: 100%;
  z-index: 1;
`;

export const HeaderSkirt = styled.div`
  height: ${(props) => props.theme.spacing20};
  background-color: ${(props) => props.theme.color.gray100};
`;

export const PageTitle = styled.p`
  color: ${(props) => props.theme.color.black};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-size: ${(props) => props.theme.fontSize.headline};
  text-align: center;
  margin: ${(props) => props.theme.spacing12};
`;

export const ContentContainer = styled.div`
  background-color: ${(props) => props.theme.color.gray100};
  min-height: ${(props) => props.dimensions.height}px;
  padding-top: ${(props) => props.theme.spacing64};
  padding-bottom: 80px;
  text-align: left;
`;

export const FieldContainer = styled.div`
  margin: ${(props) => props.theme.spacing16};
  color: black;
  background: white;
  border-radius: 8px;
  padding: ${(props) => props.theme.spacing16};
  box-shadow: 3px 2px 4px ${(props) => props.theme.color.gray200};
`;

export const FieldTitle = styled.p`
  color: ${(props) => props.theme.color.gray600};
  font-size: ${(props) => props.theme.fontSize.subhead};
  padding: 0;
  margin: 0;
`;

export const FieldValue = styled.p`
  color: ${(props) => props.theme.color.black};
  font-size: ${(props) => props.theme.fontSize.body1};
  padding: 0;
  padding-top: ${(props) => props.theme.spacing4};
  margin: 0;
`;

export const StyledInput = styled.input`
  padding: 16px 12px; /* Increased padding for more height */
  border: 1px solid #e0e0e0; /* Light gray border */
  border-radius: 8px; /* Rounded corners for the input field */
  background-color: #fff;
  font-size: ${(props) => props.theme.fontSize.body1};
  color: #333; /* Dark text color for readability */
  margin-top: ${(props) => props.theme.spacing8};
  width: 100%;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
  height: 50px; /* Explicit height for the input field to ensure it’s tall enough */

  &::placeholder {
    color: #bbb; /* Lighter gray color for the placeholder */
    font-size: ${(props) => props.theme.fontSize.body2};
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.color.pink500};
  }
`;

export const StyledButton = styled.button`
  padding: 12px 20px;
  background-color: ${(props) => props.theme.color.pink500};
  color: white;
  font-size: ${(props) => props.theme.fontSize.body1};
  border-radius: 8px; /* Rounded corners for the button */
  border: none;
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box; /* Ensures padding doesn't affect width */

  &:hover {
    background-color: ${(props) => props.theme.color.pink700};
  }
`;

export const Label = styled.label`
  font-size: ${(props) => props.theme.fontSize.body1};
  color: ${(props) => props.theme.color.black};
  margin-bottom: ${(props) => props.theme.spacing2};
  font-weight: bold;
`;

export const ErrorMessage = styled.p`
  color: ${(props) => props.theme.color.pink500};
  margintop: ${(props) => props.theme.spacing8};
`;
